module.exports = __webpack_public_path__ + "static/media/BH.b799c06d.png";